import type { AnchorStrategyCreateModel } from '@/shared/generated'

import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useCreateAnchorStrategyMutation } from '@/entities/anchor'

import { queryClient } from '@/shared/lib/query-client'
import { processingMessage } from '@/shared/tools/message'

export function useCreateAnchorStrategy(onSuccess?: () => void) {
	const { t } = useTranslation()

	const createAnchorStrategyMutation = useCreateAnchorStrategyMutation({
		onSuccess: () => {
			onSuccess?.()
			queryClient.invalidateQueries({
				queryKey: ['anchors-strategies'],
			})
			queryClient.invalidateQueries({
				queryKey: ['generated-anchor-families'],
			})
		},
	})
	const handleCreateStrategy = (data: AnchorStrategyCreateModel) => {
		toast.promise(createAnchorStrategyMutation.mutateAsync(data), {
			loading: processingMessage(t),
			success: t('toast.entity.created', {
				entity: t('entity.anchor_strategy', {
					defaultValue: 'Anchor strategy',
				}),
			}),
			error: (error) => ({
				message: t(
					'anchoring_management.strategy_page.create_anchor_strategy_error',
					{ defaultValue: 'Error creating anchor strategy' }
				),
				description: (error.response?.data as { detail: string })?.detail,
			}),
			id: 'anchor_strategy_creating',
		})
	}

	return {
		handleCreateStrategy,
		isPending: createAnchorStrategyMutation.isPending,
	}
}
